import React from "react";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

import "swiper/css";

import {
  FaReact,
  FaNodeJs,
  FaFigma,
  FaWordpress,
  FaHtml5,
  FaCss3Alt,
} from "react-icons/fa";

import {
  SiExpress,
  SiMongodb,
  SiTailwindcss,
  SiJavascript,
  SiTypescript,


  SiAutodesk,
  SiSketchup,
} from "react-icons/si";

function ToolsSection() {

  const techs = [

    {
      icon: <FaReact className="text-cyan-400" />,
      name: "React JS",
    },

    {
      icon: <FaNodeJs className="text-green-500" />,
      name: "Node JS",
    },

    {
      icon: <SiExpress className="text-black dark:text-white" />,
      name: "Express",
    },

    {
      icon: <SiMongodb className="text-green-600" />,
      name: "MongoDB",
    },

    {
      icon: <SiTailwindcss className="text-sky-400" />,
      name: "Tailwind CSS",
    },

    {
      icon: <FaFigma className="text-pink-500" />,
      name: "Figma",
    },

  

  

    {
      icon: <SiAutodesk className="text-red-500" />,
      name: "AutoCAD",
    },

    {
      icon: <SiSketchup className="text-yellow-500" />,
      name: "SketchUp",
    },

    {
      icon: <FaWordpress className="text-blue-600" />,
      name: "WordPress",
    },

    {
      icon: <SiJavascript className="text-yellow-400" />,
      name: "JavaScript",
    },

    {
      icon: <SiTypescript className="text-blue-500" />,
      name: "TypeScript",
    },

    {
      icon: <FaHtml5 className="text-orange-500" />,
      name: "HTML5",
    },

    {
      icon: <FaCss3Alt className="text-blue-500" />,
      name: "CSS3",
    },

  ];

  return (

    <section className="relative py-16 px-6 lg:px-16 overflow-hidden bg-white dark:bg-[#050505] transition-all duration-300">

      {/* BG GLOW */}
      <div className="absolute top-0 left-0 w-[400px] h-[400px] bg-primary/10 blur-[120px] rounded-full"></div>

      <div className="absolute bottom-0 right-0 w-[400px] h-[400px]bg-primary/10 blur-[120px] rounded-full"></div>

      {/* GRID */}
      <div className="absolute inset-0 
      bg-[linear-gradient(rgba(0,0,0,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(0,0,0,0.03)_1px,transparent_1px)] 
      dark:bg-[linear-gradient(rgba(255,255,255,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.03)_1px,transparent_1px)] 
      bg-[size:70px_70px]"></div>

      <div className="relative z-10 max-w-7xl mx-auto">

        {/* TOP */}
        <div className="text-center mb-14">

          <span className="inline-flex items-center gap-2 px-5 py-2 rounded-full 
          border border-primary/20 bg-primary/10 text-primary text-sm font-semibold backdrop-blur-xl">

            Modern Technologies

          </span>

          <h2 className="mt-6 text-4xl md:text-6xl font-black text-gray-900 dark:text-white">

            Tools & Technologies

            <span className="block bg-gradient-to-r from-primary via-orange-400 to-yellow-400 bg-clip-text text-transparent">

              We Work With

            </span>

          </h2>

          <p className=" myparagraph max-w-5xl mx-auto  text-gray-600 dark:text-gray-400">

            Modern development stack, premium design software,
            marketing tools and scalable technologies.

          </p>

        </div>

        {/* SWIPER */}
        <Swiper
          slidesPerView={2}
          spaceBetween={20}
          loop={true}
          speed={1200}
          autoplay={{
            delay: 1800,
            disableOnInteraction: false,
          }}
          breakpoints={{
            640: {
              slidesPerView: 3,
            },

            768: {
              slidesPerView: 4,
            },

            1024: {
              slidesPerView: 6,
            },
          }}
          modules={[Autoplay]}
        >

          {techs.map((tech, index) => (

            <SwiperSlide key={index}>

              <div className="group rounded-lg border border-gray-600/20 dark:border-white/10 
              bg-white/70 dark:bg-white/5 backdrop-blur-2xl 
              p-4 hover:scale-105 my-2
              flex flex-col items-center justify-center text-center
             ">

                {/* ICON */}
                <div className="text-5xl mb-5 group-hover:scale-110 transition duration-500">

                  {tech.icon}

                </div>

                {/* NAME */}
                <h4 className="text-sm font-semibold text-gray-800 dark:text-gray-200">

                  {tech.name}

                </h4>

              </div>

            </SwiperSlide>

          ))}

        </Swiper>

      </div>

    </section>

  );
}

export default ToolsSection;